import BackButton from "./BackButton";

const TopTitle = ({ title,backButton=true }) => {
    return (
        <div className={`  flex ${backButton? "justify-between":"justify-center"}  md:px-[20rem]  `}>
          {backButton && 
                 <BackButton 
                 depth={3}
                 />
                }
           

        <h1 className="text-5xl text-gray-300 font-extrabold underline ">
          {title}
        </h1>
         
       
      </div>
    );
};

export default TopTitle;